export const COMMENT_RESET = "COMMENT_RESET" as const;
export const COMMENT_SET = "COMMENT_SET" as const;
export const COMMENT_UPDATE = "COMMENT_UPDATE" as const;
export const COMMENT_DELETE = "COMMENT_DELETE" as const;
export const REACTION_SET = "REACTION_SET" as const;
export const SEEN_SET = "SEEN_SET" as const;
